import searchConfigURL from "@adapters/infrastructures/urlConfig/Search/searchURL";
class SearchRepository {
    constructor(http) {
        this.http = http;
    }
    async getCommFutSearch(req) {
        const url = new URL(searchConfigURL.comfut);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        !!req.exchangeType && url.searchParams.append("exchange", req.exchangeType);
        !!req.expiryDates &&
            url.searchParams.append("expiryDates", req.expiryDates);
        !!req.strikePrices &&
            url.searchParams.append("strikePrices", req.strikePrices);
        !!req.optionTypes &&
            url.searchParams.append("optionTypes", req.optionTypes);
        const comSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        const comfut = Object.assign(Object.assign({}, comSearch), { data: Object.assign(Object.assign({}, comSearch.data), { ComFut: comSearch.data.commodities }) });
        return comfut.data;
    }
    async getCommOptSearch(req) {
        const url = new URL(searchConfigURL.comopt);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        !!req.exchangeType && url.searchParams.append("exchange", req.exchangeType);
        !!req.expiryDates &&
            url.searchParams.append("expiryDates", req.expiryDates);
        !!req.strikePrices &&
            url.searchParams.append("strikePrices", req.strikePrices);
        !!req.optionTypes &&
            url.searchParams.append("optionTypes", req.optionTypes);
        const comSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        const comOpt = Object.assign(Object.assign({}, comSearch), { data: Object.assign(Object.assign({}, comSearch.data), { ComOpt: comSearch.data.commodities }) });
        return comOpt.data;
    }
    async getPrimaryMarket(req) {
        const url = new URL(searchConfigURL.pmSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        !!req.marketType && url.searchParams.append("marketTypes", req.marketType);
        const pmSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return pmSearch.data;
    }
    async getCurSearch(req) {
        const url = new URL(searchConfigURL.cuSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        !!req.category && url.searchParams.append("category", req.category);
        !!req.expiryDates &&
            url.searchParams.append("expiryDates", req.expiryDates);
        !!req.strikePrices &&
            url.searchParams.append("strikePrices", req.strikePrices);
        !!req.optionTypes &&
            url.searchParams.append("optionTypes", req.optionTypes);
        const cuSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return cuSearch.data;
    }
    async getTrending(req) {
        const url = new URL(searchConfigURL.genTrending);
        if (!!req.trendingAssetType) {
            url.searchParams.append("trendingAssetType", req.trendingAssetType);
        }
        if (!!req.recentSymbols)
            url.searchParams.append("recentSymbols", req.recentSymbols);
        const genTrending = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return genTrending.data;
    }
    async saveTrending(req) {
        const url = new URL(searchConfigURL.saveTrending + "/" + req.symbol);
        url.searchParams.append("assetType", req.assetType);
        const genTrending = await this.http.makeApiCall({
            method: "PUT",
            url: url.toString(),
        });
        return genTrending;
    }
    async getEqSearch(req) {
        const url = new URL(searchConfigURL.eqSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        !!req.exchangeType &&
            url.searchParams.append("exchanges", req.exchangeType.toString());
        const eqSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return eqSearch.data;
    }
    async getFuSearch(req) {
        const url = new URL(searchConfigURL.fuSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        const fuSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return fuSearch.data;
    }
    async getOpSearch(req) {
        const url = new URL(searchConfigURL.opSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        !!req.expiryDates &&
            url.searchParams.append("expiryDates", req.expiryDates);
        !!req.strikePrices &&
            url.searchParams.append("strikePrices", req.strikePrices);
        !!req.optionTypes &&
            url.searchParams.append("optionTypes", req.optionTypes);
        const opSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return opSearch.data;
    }
    async getCommSearch(req) {
        const url = new URL(searchConfigURL.comSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        const comSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return comSearch.data;
    }
    async getETFSSearch(req) {
        const url = new URL(searchConfigURL.etfsSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        const etfsSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return etfsSearch.data;
    }
    async getIndicesSearch(req) {
        const url = new URL(searchConfigURL.indSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        const indSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return indSearch.data;
    }
    async getNCDSearch(req) {
        const url = new URL(searchConfigURL.ncdsSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        const ncdsSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return ncdsSearch.data;
    }
    async getMFSearch(req) {
        const url = new URL(searchConfigURL.mfSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        const mfSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return mfSearch.data;
    }
    async getSGBSearch(req) {
        const url = new URL(searchConfigURL.sgbSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        const sgbSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return sgbSearch.data;
    }
    async getCorpFdSearch(req) {
        const url = new URL(searchConfigURL.corpFdSearch);
        url.searchParams.append("searchText", req.searchText);
        !!req.pageNumber &&
            url.searchParams.append("pageNumber", req.pageNumber.toString());
        !!req.pageSize &&
            url.searchParams.append("pageSize", req.pageSize.toString());
        const corpFdSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return corpFdSearch.data;
    }
    async getGeneralSearch(req) {
        const url = new URL(searchConfigURL.genSearch);
        url.searchParams.append("searchText", req.searchText);
        const genSearch = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return genSearch.data;
    }
    async getOptionChainToolData(req) {
        const url = new URL(searchConfigURL.optionChainTool);
        url.searchParams.append("searchText", req.searchText);
        const optionChainTool = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return optionChainTool.data;
    }
}
export default SearchRepository;
